import React, { useEffect, useState } from 'react'
import { AddAddress } from '../../redux/Slices/UserSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import notify from "../UseNotification"

const useAddAddressUser = () => {

    const egyptPhoneRegex = /^(010|011|012|015)\d{8}$/;
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [AddressTitle, setAddressTitle] = useState("")
    const [addressInDetails, setAddressInDetails] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [loading, setLoading] = useState(true)
    const [isPress, setIsPress] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false)
    const { addAddress } = useSelector(state => state.UserReducer)

    // handle change Address Title
    const changeAddressTitle = (e) => {
        setAddressTitle(e.target.value)
    }

    // handle change Address InDetails
    const changeAddressInDetails = (e) => {
        setAddressInDetails(e.target.value)
    }

    // handle change Phone Number
    const changePhoneNumber = (e) => {
        setPhoneNumber(e.target.value)
    }

    // handle validate address title
    const validateTitle = (e) => {
        if (e.target.value === "") {
            notify("please, enter the address title", "warn")
        }
    }

    // handle validate address details
    const validateDetails = (e) => {
        if (e.target.value === "") {
            notify("please, enter the address details", "warn")
        }
    }

    // handle validate phone number
    const validatePhoneNumber = (e) => {
        if (e.target.value === "") {
            notify("you must enter phone", "warn")
        } else if (!e.target.value.match(egyptPhoneRegex)) {
            notify("phone is not egyption number", "warn")
        }
    }

    // form  validation to disable button
    useEffect(() => {
        if (AddressTitle && addressInDetails && phoneNumber != "" && phoneNumber.match(egyptPhoneRegex)) {
            setIsFormValid(true)
        }
    }, [AddressTitle, addressInDetails, phoneNumber])


    // validate inputs
    const Validate = () => {
        if (AddressTitle === "") {
            notify("please, enter the address title", "warn")
            return false;
        }
        else if (addressInDetails === "") {
            notify("please, enter the address details", "warn")
            return false;
        }
        else if (phoneNumber === "") {
            notify("you must enter phone", "warn")
            return false;
        }
        else if (!phoneNumber.match(egyptPhoneRegex)) {
            notify("phone is not egyption number", "warn")
            return false;
        }
        return true;
    }

    
    // handle Add Address Submit
    const AddAddressSubmit = async () => {
        if (!Validate()) {
            return;
        }
        setIsPress(true)
        setLoading(true)
        await dispatch(AddAddress({
            alias: AddressTitle,
            details: addressInDetails,
            phone: phoneNumber,
            city: "",
            postalCode: ""
        }))
        setLoading(false)
    }

    // to handle request response 
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (addAddress && addAddress.status) {
                notify("Address added successfully", "success")
                navigate("/user/alladdresses")
            }
        }
    }, [loading])

    return [isFormValid, isPress, loading, validateTitle, validateDetails, validatePhoneNumber, AddressTitle, changeAddressTitle, addressInDetails, changeAddressInDetails, phoneNumber, changePhoneNumber, AddAddressSubmit]
}

export default useAddAddressUser
